var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButterfly4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 183,
    viewBox: "0 0 146 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.0676L72.1705 100.568L116.966 0L135.216 70.0676L124.432 84.0811L136.875 95.6216L146 170.635L121.114 138.486L96.2273 119.089L114.477 183L68.8523 127.77V122.698L0 70.0676Z",
    fill: "#D9E084"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.0676L72.1705 100.568L74.6591 102.216L77.1477 104.218L84.6136 110.037L96.2273 119.089L121.114 138.486L136.875 95.6216L146 170.635L121.114 138.486L96.2273 119.089L114.477 183L68.8523 127.77V122.698L0 70.0676Z",
    fill: "#AADBB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4887 127.77L83.3751 112.444L68.8523 99.1653L72.1705 100.568L74.6591 102.216L77.1478 104.218L124.432 84.0811L129.196 88.5L79.4338 106L84.6137 110.037L86.6875 111.654L96.2273 119.089L98.2007 126L85.4438 114.336L75.4887 135.804L68.8523 127.77V122.698L75.4887 127.77Z",
    fill: "#48A7A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButterfly4);
export default __webpack_public_path__ + "static/media/butterfly-4.7097068a0d20e34b67dbbb7edb168959.svg";
export { ForwardRef as ReactComponent };